import axios from "./axiosinstance";

const SalesAvailabilityApi = {
  save: (payload) =>
    axios.post("/sales-availability/save", payload),

  get: (date) =>
    axios.get(`/sales-availability/get?date=${date}`),
};

export default SalesAvailabilityApi;